import SubstackCreate from './SubstackCreate';
import NotionEmbedCode from './NotionEmbedCode';
import HTMLEmbedCode from './HTMLEmbedCode';
import NotionPaste from './NotionPaste';
import WordpressAdd from './WordpressAdd';
import WebflowPaste from './WebflowPaste';
import FramerPaste from './FramerPaste';
import CarrdPaste from './CarrdPaste';
import CarrdEmbedCode from './CarrdEmbedCode';
import BeehiivCreate from './BeehiivCreate';
import PodcastCreate from './PodcastCreate';
import RSSCreate from './RSSCreate';
import TypedreamPaste from './TypedreamPaste';
import DorikPaste from './DorikPaste';
import HTMLPaste from './HTMLPaste';
import GhostBlogCreate from './GhostBlogCreate';

export type Item = {
  name: string;
  link: string;
  calledAs: string;
  steps: React.FunctionComponent[];
  matchesToAvoid: string[];
  otherLinks?: string[];
};

export const sourceItems: Record<string, Item> = {
  substack: {
    name: 'Substack',
    link: 'https://substack.com',
    calledAs: 'newsletter archive',
    steps: [SubstackCreate],
    matchesToAvoid: [],
  },
  beehiiv: {
    name: 'beehiiv',
    calledAs: 'newsletter archive',
    link: 'https://beehiiv.com',
    steps: [BeehiivCreate],
    matchesToAvoid: [],
  },
  'ghost-blog': {
    name: 'Ghost',
    link: 'https://ghost.org',
    calledAs: 'blog',
    steps: [GhostBlogCreate],
    matchesToAvoid: ['ghost'],
  },
  podcasts: {
    name: 'Podcast',
    link: 'https://en.wikipedia.org/wiki/Podcast',
    calledAs: 'episode list',
    steps: [PodcastCreate],
    matchesToAvoid: [],
  },
  rss: {
    name: 'RSS',
    link: 'https://en.wikipedia.org/wiki/RSS',
    calledAs: 'feed',
    steps: [RSSCreate],
    matchesToAvoid: [],
  },
};

export const destinationItems: Record<string, Item> = {
  // ghost: {
  //   name: 'Ghost',
  //   link: 'https://ghost.org',
  //   calledAs: 'website',
  //   steps: [],
  //   matchesToAvoid: [],
  //   otherLinks: ['webflow', 'framer', 'wordpress'],
  // },
  notion: {
    name: 'Notion',
    link: 'https://notion.so',
    calledAs: 'page',
    steps: [NotionEmbedCode, NotionPaste],
    matchesToAvoid: [],
    otherLinks: ['feather', 'potion', 'super'],
  },
  feather: {
    name: 'feather.so',
    link: 'https://feather.so',
    calledAs: 'page',
    steps: [NotionEmbedCode, NotionPaste],
    matchesToAvoid: [],
    otherLinks: ['notion', 'potion', 'super'],
  },
  potion: {
    name: 'potion.so',
    link: 'https://potion.so',
    calledAs: 'website',
    steps: [NotionEmbedCode, NotionPaste],
    matchesToAvoid: [],
    otherLinks: ['notion', 'feather', 'super'],
  },
  super: {
    name: 'super.so',
    link: 'https://super.so',
    calledAs: 'site',
    steps: [NotionEmbedCode, NotionPaste],
    matchesToAvoid: [],
    otherLinks: ['notion', 'feather', 'potion'],
  },
  wordpress: {
    name: 'WordPress',
    link: 'https://wordpress.com',
    calledAs: 'page',
    steps: [HTMLEmbedCode, WordpressAdd],
    matchesToAvoid: [],
    otherLinks: ['webflow', 'framer', 'notion'],
  },
  webflow: {
    name: 'Webflow',
    link: 'https://webflow.com',
    calledAs: 'site',
    steps: [
      // TODO webflow tab
      HTMLEmbedCode,
      WebflowPaste,
    ],
    matchesToAvoid: [],
    otherLinks: ['wordpress', 'framer', 'notion'],
  },
  framer: {
    name: 'Framer',
    link: 'https://framer.com',
    calledAs: 'site',
    steps: [HTMLEmbedCode, FramerPaste],
    matchesToAvoid: [],
    otherLinks: ['wordpress', 'webflow', 'notion'],
  },
  carrd: {
    name: 'Carrd',
    link: 'https://carrd.co',
    calledAs: 'site',
    steps: [CarrdEmbedCode, CarrdPaste],
    matchesToAvoid: [],
    otherLinks: ['webflow', 'framer', 'wordpress'],
  },
  typedream: {
    name: 'Typedream',
    link: 'https://typedream.com',
    calledAs: 'site',
    steps: [NotionEmbedCode, TypedreamPaste],
    matchesToAvoid: [],
    otherLinks: ['webflow', 'framer', 'wordpress', 'dorik'],
  },
  dorik: {
    name: 'Dorik',
    link: 'https://dorik.com/',
    calledAs: 'website',
    steps: [NotionEmbedCode, DorikPaste],
    matchesToAvoid: [],
    otherLinks: ['typedream', 'webflow', 'framer', 'wordpress'],
  },
  html: {
    name: 'HTML',
    link: 'https://en.wikipedia.org/wiki/HTML',
    calledAs: 'page',
    steps: [HTMLEmbedCode, HTMLPaste],
    matchesToAvoid: [],
    otherLinks: ['webflow', 'framer', 'wordpress'],
  },
  // wix
};

export const extraDestinationContent: Record<string, React.FunctionComponent> = {
  notion: function NotionContent() {
    return (
      <div>
        <aside className="bg-gray-100 p-4 rounded">
          ⭐ This works for all the website generator tools, like{' '}
          <a href="https://feather.so?utm_source=stackblocks">feather.so</a>,{' '}
          <a href="http://Potion.so?utm_source=stackblocks">Potion.so</a>,{' '}
          <a href="http://super.so?utm_source=stackblocks">super.so</a>, etc, which are built on top
          of Notion.
        </aside>
        <p>A couple of use cases why you'd want to do this.</p>
        <ul>
          <li>
            You are building a landing page for yourself and you want to show a preview of the
            issues you've sent in your newsletter.
          </li>
          <li>
            You are creating a course in Notion and as part of resources, you want to embed the
            newsletter with rich previews.
          </li>
        </ul>
        <hr />
      </div>
    );
  },
  feather: function FeatherContent() {
    return (
      <div>
        <aside className="bg-gray-100 p-4 rounded">
          💡 This can be embedded in a single page, or in a specific section which will be common
          for all the pages.
        </aside>
      </div>
    );
  },
  carrd: function CarrdContent() {
    return <p>You will need a Pro subscription to be able to embed widgets.</p>;
  },
};

const getGuidesPaths = () => {
  const paths: string[] = [];

  const sources = Object.keys(sourceItems);
  const destinations = Object.keys(destinationItems);

  sources.forEach((source) => {
    destinations.forEach((destination) => {
      paths.push(`how-to-embed-${source}-in-${destination}`);
    });
  });

  return paths;
};

export default getGuidesPaths;
